// extracted by mini-css-extract-plugin
module.exports = {"scrollable":"Sankey_scrollable__3Mw3P","sankey":"Sankey_sankey__3uoQe","echart":"Sankey_echart__P8O2n"};